// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  automaticAbsence: (t, data?, options?) => t('enum.cancellation-reason.automatic-absence.name', data, options),
  automaticPartialAbsence: (t, data?, options?) => t('enum.cancellation-reason.automatic-partial-absence.name', data, options),
  connection: (t, data?, options?) => t('enum.cancellation-reason.connection.name', data, options),
  equipment: (t, data?, options?) => t('enum.cancellation-reason.equipment.name', data, options),
  health: (t, data?, options?) => t('enum.cancellation-reason.health.name', data, options),
  lateManual: (t, data?, options?) => t('enum.cancellation-reason.late-manual.name', data, options),
  legacy: (t, data?, options?) => t('enum.cancellation-reason.legacy.name', data, options),
  manual: (t, data?, options?) => t('enum.cancellation-reason.manual.name', data, options),
  office: (t, data?, options?) => t('enum.cancellation-reason.office.name', data, options),
  other: (t, data?, options?) => t('enum.cancellation-reason.other.name', data, options),
  personal: (t, data?, options?) => t('enum.cancellation-reason.personal.name', data, options),
  power: (t, data?, options?) => t('enum.cancellation-reason.power.name', data, options),
  readyButton: (t, data?, options?) => t('enum.cancellation-reason.ready-button.name', data, options),
  selfBooking: (t, data?, options?) => t('enum.cancellation-reason.self-booking.name', data, options),
  skype: (t, data?, options?) => t('enum.cancellation-reason.skype.name', data, options),
  staffRecordedAbsence: (t, data?, options?) => t('enum.cancellation-reason.staff-recorded-absence.name', data, options),
  studentAccountClose: (t, data?, options?) => t('enum.cancellation-reason.student-account-close.name', data, options),
  teacherAccountClose: (t, data?, options?) => t('enum.cancellation-reason.teacher-account-close.name', data, options),
  teacherRecordedAbsence: (t, data?, options?) => t('enum.cancellation-reason.teacher-recorded-absence.name', data, options),
  /* eslint-enable max-len */
};
